import { c as _c } from "react/compiler-runtime";
import { TableHeader, TableHeaderCell } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { TABLE_ROW_CLASS_NAMES, tableRowColumns } from "./utils";
export function ProfilePreviewTooltipCollectionTableHeader() {
  const $ = _c(19);
  const t = useTranslations("ProfilePreviewTooltipCollectionTableHeader");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = tableRowColumns.collection();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("collection");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <TableHeaderCell className={t0}>{t1}</TableHeaderCell>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = tableRowColumns.held();
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("held");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <TableHeaderCell className={t3}>{t4}</TableHeaderCell>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = tableRowColumns.value();
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("value");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <TableHeaderCell className={t6}>{t7}</TableHeaderCell>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t5 || $[17] !== t8) {
    t9 = <TableHeader className={TABLE_ROW_CLASS_NAMES}>{t2}{t5}{t8}</TableHeader>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}